export default __webpack_public_path__ + "static/imgTyre-e99a48e3d70d5a32a1cde9b3339420e1.webp";